export const TempoRange = { min: 30, max: 1000, default: 120.0 };
